<template>
  <div>
    <v-card-title class="px-0 my-0">Notes</v-card-title>
    <v-row justify="end" v-if="!readonly">
      <v-col cols="12" sm="6" lg="4" xl="3">
        <v-btn block outlined color="primary" @click="showCreateNoteModalHandler">
          ADD NOTE
          <v-icon right >add</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mb-6" v-if="todoNoteList.length === 0">
      <v-col cols="12">
        There are no notes to show.
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="(note, index) in todoNoteList"
        :key="index"
        cols="12"
      >
          <span>
            <b>
            {{ note.userFullName }}
            -
            {{ note.createdAt | formatDate }} {{ note.createdAt | toTimeOnlyString }}
            </b>
          </span>
        <p>{{ note.notes }}</p>
      </v-col>
    </v-row>
    <v-row
      v-if="todoNoteList.length > 0"
      class="mb-6"
    ></v-row>
    <TodoNoteEdit
      ref="todoNoteEdit"
      :todoIdIn="todoId"
      @savedNote="savedNoteHandler"
    ></TodoNoteEdit>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import TodoNoteEdit from './TodoNoteEdit'
import { ButtonCustomIcon } from '@/components/buttons'
import { DynamicModal } from '@/components/dialogs'

export default {
  props: [
    'todoIdIn',
    'readonly'
  ],
  components: {
    ButtonCustomIcon,
    TodoNoteEdit,
    DynamicModal
  },
  data () {
    return {
      showCreateNoteModal: false,
      activePreload: true
    }
  },
  computed: {
    ...mapFields('todoNoteFilters', [
      'todoId'
    ]),
    ...mapFields('todoNotes', [
      'todoNoteList'
    ])
  },
  methods: {
    ...mapActions('todoNotes', [
      'getTodosWithFilters'
    ]),
    loadTodoNotes () {
      this.todoId = this.todoIdIn
      this.getTodosWithFilters()
    },
    showCreateNoteModalHandler () {
      this.$refs.todoNoteEdit.showModal()
    },
    savedNoteHandler () {
      this.loadTodoNotes()
    }
  },
  created () {
    this.loadTodoNotes()
  }
}
</script>

<style>

</style>
